import { getInitials } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarAvatar } from './avatar';
import { SonarText } from './text';
import { SonarUserTooltip } from './SonarUserTooltip';
import { useCurrentUser } from '@hooks';
import { Space } from 'antd';
export const SalesforceUser = ({ avatar = true, className, large, name = '', placeholder, shape, showTooltip, username, withFullName = true }) => {
    const { isGuest } = useCurrentUser();
    const [firstName, lastName] = name.split(' ');
    const initials = getInitials(firstName, lastName);
    let avatarElement;
    let labelElement;
    if (avatar) {
        avatarElement =
            React.createElement(SonarAvatar, { className: className, isPlaceholder: !name, large: large, shape: shape }, initials);
    }
    if (withFullName || placeholder) {
        labelElement = React.createElement(SonarText, { className: 'salesforce-user-label' }, name.length ? name : placeholder);
    }
    const userBase = React.createElement(Space, { className: 'salesforce-user', key: username, size: 8 },
        avatarElement,
        labelElement);
    if (showTooltip && !isGuest) {
        return (React.createElement(SonarUserTooltip, { avatar: avatarElement, email: username, name: name }, userBase));
    }
    return userBase;
};
